const pageNameKey = "refreshTokenExpiredError";

export const refreshTokenExpiredErrorEn = {
  [pageNameKey]: {
    hintTitle: "We're having difficulties connecting to the server.",
    title: "All your tokens expired",
    button: "Refresh",
  },
};

export const refreshTokenExpiredErrorPtBr = {
  [pageNameKey]: {
    hintTitle: "Estamos com dificuldades para nos conectar ao servidor.",
    title: "Todos os seus tokens expiraram",
    button: "Atualizar",
  },
};

export const refreshTokenExpiredErrorDe = {
  [pageNameKey]: {
    hintTitle: "Wir haben Schwierigkeiten, uns mit dem Server zu verbinden.",
    title: "Alle Token sind abgelaufen",
    button: "Aktualisieren",
  },
};

export const refreshTokenExpiredErrorZhHans = {
  [pageNameKey]: {
    hintTitle: "我们在连接服务器时遇到困难。",
    title: "您的所有令牌已过期",
    button: "刷新",
  },
};

export const refreshTokenExpiredErrorIt = {
  [pageNameKey]: {
    hintTitle: "Stiamo riscontrando difficoltà a connetterci al server.",
    title: "Tutti i tuoi token sono scaduti",
    button: "Aggiorna",
  },
};

export const refreshTokenExpiredErrorEs = {
  [pageNameKey]: {
    hintTitle: "Estamos teniendo dificultades para conectarnos al servidor.",
    title: "Todos tus tokens expiraron",
    button: "Actualizar",
  },
};

export const refreshTokenExpiredErrorNl = {
  [pageNameKey]: {
    hintTitle: "We hebben moeite om verbinding te maken met de server.",
    title: "Al uw tokens zijn verlopen",
    button: "Vernieuwen",
  },
};

export const refreshTokenExpiredErrorTr = {
  [pageNameKey]: {
    button: "Yenile",
    hintTitle: "Sunucuya bağlanmada zorluk yaşıyoruz.",
    title: "Tüm belirteçlerinizin süresi doldu",
  },
};
